<nf-table-layout
  tableTitle="External Comparison"
  [data]="positionComparisonData | async"
  [modules]="gridModules"
  [gridOptions]="gridOptions"
  hideTitle
  [autoResizeGrid]="false"
  hideSearch
  hideClearAll
>
  <nf-table-properties [currentProperties]="propertiesTitle" [isOpen]="false">
    <div class="quick-filters">
      <label>
        Include Valuation Data
        <nf-toggle
          elId="include-valuation-data"
          name="Include Valuation Data"
          ngDefaultControl
          [(ngModel)]="includeValuationData"
          (ngModelChange)="reloadData()"
          states="true"
        ></nf-toggle>
      </label>
      <label>
        Only Cleared
        <nf-toggle
          elId="cleared-only"
          name="Cleared Only"
          ngDefaultControl
          [(ngModel)]="clearedOnly"
          (ngModelChange)="reloadData()"
          states="true"
        ></nf-toggle>
      </label>
      <label>
        Display Dynamic Rows
        <nf-toggle
          [formControl]="displayDynamicRows"
          (change)="toggleDynamicRows()"
          states="true"
        ></nf-toggle
      ></label>
    </div>
  </nf-table-properties>
</nf-table-layout>
